import * as eh from '../helpers/event-helper';
import { saveExcel } from '../helpers/excel';
import moment from 'moment';

export function getReportName(event) {
  return `${moment().format('YYYYMMDD')}_${event.airline}-${
    event.outboundNumber
  }_Report`;
}

export function getUralReportData(event) {
  const { outbound } = event;
  let { cargo, auxServices, excessBaggage } = outbound;
  auxServices = auxServices || {};
  excessBaggage = excessBaggage || {};

  return {
    dep_plan_date: event.STD,
    dep_fact_date: outbound.ATD,
    flt_num: event.outboundNumber,
    dep_airport: event.airport,
    arr_airport: event.outboundAirport,
    aircraft: outbound.aircraftReg,
    pax_count_adt: eh.getTotalAdultsCount(outbound.actualPaxLoad) ?? 0,
    pax_count_chd: eh.getTotalChildrenCount(outbound.actualPaxLoad) ?? 0,
    pax_count_inf: eh.getTotalInfantCount(outbound.actualPaxLoad) ?? 0,
    pax_count_promo: excessBaggage.promoFarePaxNo,
    bag_piece: eh.getTotalBagsCount(outbound.actualPaxLoad) ?? 0,
    bag_weight: eh.getTotalBagsWeight(outbound.actualPaxLoad) ?? 0,
    bag_pay_piece: excessBaggage.additionalPaidBaggage,
    bag_pay_weight: excessBaggage.overweightBaggage,
    bag_pay_cost: excessBaggage.baggageExcess,
    bag_hand_pay_cost: excessBaggage.handLuggageExcess,
    bag_pay_cost_promo: excessBaggage.promoExcess,
    cargo_weight: eh.getTotalCargoWeight(cargo) ?? 0,
    mail_weight: 0,
    mail_pay_weight: 0,
    delay_reason: outbound.notesForAirline,
    cold_drinks: outbound.delaysServices?.drinks?.amount ?? 0,
    hot_meal: outbound.delaysServices?.hotMeals?.amount ?? 0,
    hotel_info: outbound.delaysServices?.hotel?.paxNo ?? 0,
    pets_amount: auxServices.pets,
    unmr_amount: auxServices.unaccompaniedMinors,
    commercial_mail_amount: auxServices.commercialMail,
    checkin_delayed_pax_amount: auxServices.lateCheckInPax,
    choice_seat_amount: auxServices.seatSelection,
    upgrade_class_amount: auxServices.upgrade,
  };
}

const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm';

export function createUralReportExcel(event) {
  const reportData = getUralReportData(event);

  const report = {
    'departure date plan': moment
      .utc(reportData.dep_plan_date)
      .format(DATE_TIME_FORMAT),
    'departure date fact': reportData.dep_fact_date
      ? moment.utc(reportData.dep_fact_date).format(DATE_TIME_FORMAT)
      : '',
    'flight num': reportData.flt_num,
    'departure airport': reportData.dep_airport,
    'arrival airport': reportData.arr_airport,
    'aircraft number': reportData.aircraft,
    adults: reportData.pax_count_adt,
    children: reportData.pax_count_chd,
    infants: reportData.pax_count_inf,
    'with Promo': reportData.pax_count_promo,
    'luggage PC': reportData.bag_piece,
    'luggage kg': reportData.bag_weight,
    'pay luggage PC': reportData.bag_pay_piece,
    'pay luggage kg': reportData.bag_pay_weight,
    'pay luggage cost': reportData.bag_pay_cost,
    'pay hand lugg. cost': reportData.bag_hand_pay_cost,
    'Promo cost': reportData.bag_pay_cost_promo,
    'cargo kg': reportData.cargo_weight,
    'mail kg': reportData.mail_weight,
    'mail cost': reportData.mail_pay_weight,
    remarks: reportData.delay_reason,
    'delay cold drinks': reportData.cold_drinks,
    'delay hot meal': reportData.hot_meal,
    'delay hotel pax': reportData.hotel_info,
    'pets cost': reportData.pets_amount,
    'umnr cost': reportData.unmr_amount,
    'commercial mail cost': reportData.commercial_mail_amount,
    'late check in pax cost': reportData.checkin_delayed_pax_amount,
    'seat selection cost': reportData.choice_seat_amount,
    'upgrade cost': reportData.upgrade_class_amount,
  };

  const columnNames = Object.keys(report);
  const data = [Object.values(report)];
  return saveExcel({
    fileName: getReportName(event),
    columnNames,
    data,
    offset: 1,
  });
}
